import { viteEnv } from "utils/vite-env.util";

export const getPortalUrl = (): string => {
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    return `http://${window.location.hostname}:3001`;
  } else if (viteEnv.VITE_ENV === "prod" || viteEnv.VITE_ENV === "preprod") {
    return "https://suno.care";
  } else {
    return "https://master.suno.care";
  }
};

// Canonical URL slug for a practice name. '/', '-', and spaces are all
// collapsed into a single '-' before encoding so the slug occupies one path
// segment and doesn't emit runs of dashes for names like
// "Premier / Audiology & - Hearing Aids". Must stay in sync with the backend
// helper `Practice.compute_url_slug` in suno-backend.
export const buildPracticeSlug = (practiceName: string): string =>
  encodeURIComponent(practiceName.replace(/[-/ ]+/g, "-").toLocaleLowerCase());

export const buildPatientPortalLink = ({
  practice,
  clinicId
}: {
  practice: { id?: string; name?: string } | null | undefined;
  clinicId: string | number | null | undefined;
}): string => {
  const slug = practice?.name ? buildPracticeSlug(practice.name) : "";
  return `${getPortalUrl()}/${slug}/?practice_id=${practice?.id ?? ""}&clinic_id=${
    clinicId ?? ""
  }`;
};
